import { useQuery } from '@tanstack/react-query';
import api from '../api/api';
import { queryKeys } from './queryKeys';

export const useArtist = (id) => {
  return useQuery({
    queryKey: queryKeys.artists.detail(id),
    queryFn: async () => {
      const response = await api.get(`/artists/${id}`);
      return response.data?.data || response.data;
    },
    enabled: !!id,
  });
};
